module.exports = __webpack_public_path__ + "static/media/uttam.73253c6f.jpg";